<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12">
        <rack-display> </rack-display>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-xl-12 col-lg-11 col-md-10">
        <shelved></shelved>
      </div>
    </div> -->
  </div>
</template>
<script>
import RackDisplay from "./Display/RackDisplay.vue";
// import Shelved from "@/pages/Shelved.vue";
export default {
  components: {
    RackDisplay,
    // Shelved
  },
};
</script>
<style>
</style>